import React from 'react';
import { useNavigate } from 'react-router-dom';
import GameContainer from '../GameContainer/GameContainer.tsx';
import { GameType } from '../../types/GameType.ts';
import { getGameConfig } from '../../types/GameConfig.ts';
import { getIconComponent } from '../../utils/iconUtils.ts';
import './HomePage.css';

// Helper function to convert hex color to rgba with opacity
const hexToRgba = (hex: string, opacity: number): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export default function HomePage() {
  const navigate = useNavigate();

  const handleGameSelect = (gameType: GameType) => {
    const gameConfig = getGameConfig(gameType);
    navigate(gameConfig.routePath);
  };

  // Get all available game types
  const allGameTypes = Object.values(GameType);
  
  // Filter to get only launched games
  const launchedGameTypes = allGameTypes.filter(gameType => {
    const gameConfig = getGameConfig(gameType);
    return gameConfig.hasGameLaunched();
  });

  return (
    <GameContainer title="Weaver Games">
      <div className="homePageContainer">
        <div className="gameCardsGrid">
          {launchedGameTypes.map((gameType) => {
            const gameConfig = getGameConfig(gameType);
            const IconComponent = getIconComponent(gameConfig.icon);
            
            return (
              <div 
                key={gameType} 
                className="gameCard" 
                onClick={() => handleGameSelect(gameType)}
                style={{ 
                  backgroundColor: hexToRgba(gameConfig.primaryColor, 0.9)
                }}
              >
                {IconComponent && (
                  <IconComponent className="gameCardIcon" style={{ width: 80, height: 80 }} />
                )}
                <div className="gameCardContent">
                  <h2 className="gameCardTitle">
                    {gameConfig.name}
                  </h2>
                  <p className="gameCardDescription">
                    {gameConfig.shortDescription}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </GameContainer>
  );
} 